import axios from '../utils/axios';
import qs from 'qs';
import { BaseDataResponse, BaseResponse } from '@/type';
import { AUTH_STATUS, PrincipalType } from '@/type/enums';
export { AUTH_STATUS, PrincipalType } from '@/type/enums'; // 因为之前写在这个文件里，后面多方使用，抽成了公共文件

export interface PrincipalTypeConfig {
    principalType: string
    enterpriseName: string
    businessLicense: string
    corporationInfo: string
}

// 资质认证上传身份认证信息
export async function submitVote(code: string, idToken: string, param: any) {
    param.idToken = idToken;
    const res = await axios.post(
        `/portal/developer/v3/create?phoneVerifyCode=${code}`,
        qs.stringify(param),
    );
    return res.data;
}

// 重新提交资质认证信息
export async function reSubmitVote(code: string, idToken: string, param: any) {
    param.idToken = idToken;
    const res = await axios.post(
        `/portal/developer/v3/update?phoneVerifyCode=${code}`,
        qs.stringify(param),
    );
    return res.data;
}

// 资质认证上传身份认证信息 - 第二版 为了支持后端灰度，单独起接口
export async function submitVoteV2(code: string, idToken: string, param: any) {
    param.idToken = idToken;
    const res = await axios.post(
        `/portal/developer/v3/create?phoneVerifyCode=${code}&version=4`,
        qs.stringify(param),
    );
    return res.data;
}

// 重新提交资质认证信息，-第二版 为了支持后端灰度，单独起接口
export async function reSubmitVoteV2(code: string, idToken: string, param: any) {
    param.idToken = idToken;
    const res = await axios.post(
        `/portal/developer/v3/update?phoneVerifyCode=${code}&version=4`,
        qs.stringify(param),
    );
    return res.data;
}

// 获取资质认证上传身份认证信息
export async function getSubmitVote() {
    const res = await axios.post('/portal/developer/v3/info');
    return res.data;
}

// 获取邮箱验证码
export async function getEmailCode(sid: string, email: string) {
    const res = await axios.post(
        `${process.env.EMAILHOST}pass/kuaishou/email/capacheConfig`,
        {
            sid,
            email,
        },
        {
            withCredentials: true,
        },
    );
    return res.data;
}

export async function emailSendCode(param: any) {
    const res = await axios.post(
        `${process.env.EMAILHOST}account/mail/verify`,
        param,
        {
            withCredentials: true,
        },
    );
    return res.data;
}

export async function emailActivate(param: any) {
    const res = await axios.post(
        `${process.env.EMAILHOST}account/mail/active`,
        param,
        {
            withCredentials: true,
        },
    );
    return res.data;
}

export async function accountChangeEmail(param: any) {
    const res = await axios.post(
        `${process.env.EMAILHOST}account/user/change/mail`,
        param,
        {
            withCredentials: true,
        },
    );
    return res.data;
}
export async function accountSendMailCode(params: any) {
    const res = await axios.get(
        `${process.env.EMAILHOST}account/user/send/new/mail/code`,
        { params },
    );
    return res.data;
}

// 重新发送邮箱验证码
export async function emailResendCode(param: any) {
    const res = await axios.post(
        `${process.env.EMAILHOST}account/mail/reSend`,
        param,
        {
            withCredentials: true,
        },
    );
    return res.data;
}

export async function accountChangeEmailResendCode(params: any) {
    const res = await axios.get(
        `${process.env.EMAILHOST}account/user/resend/new/mail/code`,
        { params },
    );
    return res.data;
}

// 邮箱绑定/注册
export async function emailVerify(param: any) {
    const res = await axios.post(
        `${process.env.EMAILHOST}account/mail/register`,
        param,
        {
            withCredentials: true,
        },
    );
    return res.data;
}

export async function emailBind(param: any) {
    const res = await axios.post(
        `${process.env.EMAILHOST}account/mail/bind`,
        param,
        {
            withCredentials: true,
        },
    );
    return res.data;
}

// 验证码的配置
export async function getVerify(param: object) {
    const res = await axios.post(
        `${process.env.EMAILHOST}account/mail/captchaConfig`,
        param,
        {
            withCredentials: true,
        },
    );
    return res.data.data;
}

export async function uploadRegisterFile(file: any, params?: any) {
    let res;
    const formData = new FormData();
    formData.append('file', file);
    if (params && params.type) {
        Object.keys(params).forEach((e: any) => {
            formData.append(e, params[e]);
        });
    }
    const config = {
        headers: { 'Content-Type': 'multipart/form-data' },
    };
    res = await axios.post('/account/file/upload', formData, config);
    return res;
}

interface SupplementInfo {
    corporationName: string;
    corporationIdNumber: string;
    corporationIdFrontImgPath: string;
    corporationIdBackImgPath: string;
    settleInApplicationPath: string;
}

// 请求已补充信息
export async function getSupplementInfo(auditId?: string) {
    const res = await axios.get<
        BaseDataResponse<{
            existData: SupplementInfo;
            rejectReason: string;
            draftData: SupplementInfo;
            auditStatus: 'WAIT' | 'REJECT' | 'APPROVE' | 'NONE';
        }>
    >('/portal/developer/v3/qualification/complete/info', {
        params: {
            auditId,
            platform: 'OPEN_PLATFORM',
        },
    });
    return res.data;
}

// 提交未补充信息
export async function applySupplementInfo(params: SupplementInfo) {
    const res = await axios.post<BaseResponse>(
        '/portal/developer/v3/qualification/complete',
        qs.stringify({
            ...params,
            platform: 'OPEN_PLATFORM',
        }),
    );
    return res.data;
}

// 发起验真（创建一个验真单）
export async function createAuthFlow() {
    const res = await axios.post<BaseDataResponse<{
        authenticationLink: string;
    }>>(
        `/portal/account/truth/authentication/create`
    );
    return res.data;
}

// 查询用户上次验真状态
export async function getAuthStatus() {
    const res = await axios.get<
        BaseDataResponse<{
            authenticationStatus: AUTH_STATUS;
            authenticationTimes: number;
            authenticationMaxTimes: number;
        }>
    >('/portal/account/truth/authentication/status');
    return res.data.data ?? {};
}

// 查询用户是否命中灰度 废弃 后端现已全量
export async function isRegisterV2() {
    const res = await axios.get<
        {
            useNewRegisterPage: Boolean;
        }
    >('/portal/account/qualification/gray');
    return res.data?.useNewRegisterPage ?? false;
}

// 查看资质字段名称展示
export async function getPrincipalTypeConfig() {
    const res = await axios.get<
        BaseDataResponse<
            Record<PrincipalType, PrincipalTypeConfig>
        >
    >('/portal/developer/v3/registerForm/config');
    return res.data?.data ?? {};
}
